
const LogoImg = () => {
  const hostname = window.location.hostname;

  const imageMap = {
    'bk.safewalks.kr': `${process.env.PUBLIC_URL}/img/login_logo1.png`,
    'cmms.safewalks.kr': `${process.env.PUBLIC_URL}/img/login_logo2.png`,
  };

  const imageSrc = imageMap[hostname] || `${process.env.PUBLIC_URL}/img/login_logo2.png`;

  return <img src={imageSrc} alt="logo" />;
};

export default LogoImg;